module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop5.bb48ccb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop5.jpg
// module id = BAq0
// module chunks = 0